<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" />
      </template>
    </template>
    <main class="common-main">
      <!-- 認証済みの時はメインの画面を表示 -->
      <template v-if="signedIn">
        <template v-if="isAdmin">
          <h2 class="common-title">CancerWith Insight【社外秘】</h2>
          <div class="item" style="color:red">
            数値データは社外秘です。<br>
            開示の際はNDAを結ぶか、実数をそのまま利用せずに数値を丸める等の工夫をすること。
          </div>
          <span class="item">※ここで扱う「アカウント」は、メール認証・アカウント設定まで完了しているアカウント</span>
          <br>
          <br><br>
          <div class="help">
            <dl class="item">
              <li><a href="#totalUserCount">合計ユーザー数</a></li>
              <li><a href="#createAtStaticDaily">新規アカウント登録者数（日次）</a></li>
              <li><a href="#createAtStaticMonthly">新規アカウント登録者数（月次）</a></li>
              <li><a href="#averageAge">平均年齢</a></li>
              <li><a href="#countByGeneration">年代別アカウント数</a></li>
              <li><a href="#countByGender">性別別アカウント数</a></li>
              <li><a href="#countByCancerType">がん種別アカウント数</a></li>
              <li><a href="#countByCancerStage">がんステージ別アカウント数</a></li>
              <li><a href="#countByCurativeStatus">現在の状況別アカウント数</a></li>
              <li><a href="#countByRelationship">続柄別アカウント数</a></li>
              <li><a href="#counselingStaticDaily">新規相談数（日次）</a></li>
              <li><a href="#counselingStaticMonthly">新規相談数（月次）</a></li>
              <li><a href="#counselingStaticPerson">一人あたりの相談件数</a></li>
              <li><a href="#averageCounselingStaticPerson">一人あたりの平均相談件数</a></li>
              <li><a href="#averageActiveUserCounselingStaticPerson">1件以上の相談をしたことがあるユーザーにおける、一人あたりの平均相談件数</a></li>
              <li><a href="#totalCounselingCount">合計相談件数</a></li>
              <li><a href="#totalTimelineCount">合計タイムライン数</a></li>
              <li><a href="#timelineUsage">タイムライン使用ユーザー率</a></li>
            </dl>
          </div>
          <hr>


          <h3 class="common-title" id="totalUserCount">合計ユーザー数</h3>
          <span class="item">{{totalUserCount}} 件</span>
          <br>
          <br>

          <h3 class="common-title" id="createAtStaticDaily">新規アカウント登録者数（日次）</h3>
          <button class="item" @click="downloadCSV(createAtStaticDailyRows, '新規アカウント登録者数（日次）')">Download CSV</button>
          <br>
          <div class="item" style="max-width: 600px">
            <vue-good-table
              :columns="createAtStaticDailyColumns"
              :rows="createAtStaticDailyRows"
              max-height="400px"
              :fixed-header="true"
              :line-numbers="true"
              :sort-options="{
                enabled: true,
                initialSortBy: {field: 'createAt', type: 'desc'}
              }"    
            >
            </vue-good-table>
          </div>
          <div class="item" style="max-width: 600px; margin-top: 15px">
            <Chart 
              :def="chartDefBar"
              :data="createAtStaticDailyChartData"
            >
            </Chart>
          </div>
          <br>

          <h3 class="common-title" id="createAtStaticMonthly">新規アカウント登録者数（月次）</h3>
          <button class="item" @click="downloadCSV(createAtStaticMonthlyRows, '新規アカウント登録者数（月次）')">Download CSV</button>
          <br>
          <div class="item" style="max-width: 600px">
            <vue-good-table
              :columns="createAtStaticMonthlyColumns"
              :rows="createAtStaticMonthlyRows"
              max-height="400px"
              :fixed-header="true"
              :line-numbers="true"
              :sort-options="{
                enabled: true,
                initialSortBy: {field: 'createAt', type: 'desc'}
              }"    
            >
            </vue-good-table>
          </div>
          <div class="item" style="max-width: 600px; margin-top: 15px">
            <Chart 
              :def="chartDefBar"
              :data="createAtStaticMonthlyChartData"
            >
            </Chart>
          </div>
          <br>

          <h3 class="common-title" id="averageAge">平均年齢</h3>
          <span class="item">{{averageAge}} 歳</span>
          <br>
          <br>

          <h3 class="common-title" id="countByGeneration">年代別アカウント数</h3>
          <button class="item" @click="downloadCSV(countByGenerationRows, '年代別アカウント数')">Download CSV</button>
          <br>
          <div class="item" style="max-width: 600px">
            <vue-good-table
              :columns="countByGenerationColumns"
              :rows="countByGenerationRows"
              max-height="400px"
              :fixed-header="true"
              :line-numbers="true"
              :sort-options="{
                enabled: true,
                initialSortBy: {field: 'generation', type: 'asc'}
              }"  
            >
            </vue-good-table>
          </div>
          <div class="item" style="max-width: 600px; margin-top: 15px">
            <Chart 
              :def="chartDefPie"
              :data="countByGenerationChartData"
            >
            </Chart>
          </div>
          <br>

          <h3 class="common-title" id="countByGender">性別別アカウント数</h3>
          <button class="item" @click="downloadCSV(countByGenderRows, '性別別アカウント数')">Download CSV</button>
          <br>
          <div class="item" style="max-width: 600px">
            <vue-good-table
              :columns="countByGenderColumns"
              :rows="countByGenderRows"
              max-height="400px"
              :fixed-header="true"
              :line-numbers="true"
              :sort-options="{
                enabled: true,
                initialSortBy: {field: 'gender', type: 'asc'}
              }"  
            >
            </vue-good-table>
          </div>
          <div class="item" style="max-width: 600px; margin-top: 15px">
            <Chart 
              :def="chartDefPie"
              :data="countByGenderChartData"
            >
            </Chart>
          </div>
          <br>

          <h3 class="common-title" id="countByCancerType">がん種別アカウント数</h3>
          <button class="item" @click="downloadCSV(countByCancerTypeRows, 'がん種別アカウント数')">Download CSV</button>
          <br>
          <div class="item" style="max-width: 600px">
            <vue-good-table
              :columns="countByCancerTypeColumns"
              :rows="countByCancerTypeRows"
              max-height="400px"
              :fixed-header="true"
              :line-numbers="true"
              :sort-options="{
                enabled: true,
                initialSortBy: {field: 'cancerType', type: 'asc'}
              }"  
            >
            </vue-good-table>
          </div>
          <div class="item" style="max-width: 600px; margin-top: 15px">
            <Chart 
              :def="chartDefPie"
              :data="countByCancerTypeChartData"
            >
            </Chart>
          </div>
          <br>

          <h3 class="common-title" id="countByCancerStage">がんステージ別アカウント数</h3>
          <button class="item" @click="downloadCSV(countByCancerStageRows, 'がんステージ別アカウント数')">Download CSV</button>
          <br>
          <div class="item" style="max-width: 600px">
            <vue-good-table
              :columns="countByCancerStageColumns"
              :rows="countByCancerStageRows"
              max-height="400px"
              :fixed-header="true"
              :line-numbers="true"
              :sort-options="{
                enabled: true,
                initialSortBy: {field: 'cancerStage', type: 'asc'}
              }"  
            >
            </vue-good-table>
          </div>
          <div class="item" style="max-width: 600px; margin-top: 15px">
            <Chart 
              :def="chartDefPie"
              :data="countByCancerStageChartData"
            >
            </Chart>
          </div>
          <br>

          <h3 class="common-title" id="countByCurativeStatus">現在の状況別アカウント数</h3>
          <button class="item" @click="downloadCSV(countByCurativeStatusRows, '現在の状況別アカウント数')">Download CSV</button>
          <br>
          <div class="item" style="max-width: 600px">
            <vue-good-table
              :columns="countByCurativeStatusColumns"
              :rows="countByCurativeStatusRows"
              max-height="400px"
              :fixed-header="true"
              :line-numbers="true"
              :sort-options="{
                enabled: true,
                initialSortBy: {field: 'curativeStatus', type: 'asc'}
              }"  
            >
            </vue-good-table>
          </div>
          <div class="item" style="max-width: 600px; margin-top: 15px">
            <Chart 
              :def="chartDefPie"
              :data="countByCurativeStatusChartData"
            >
            </Chart>
          </div>
          <br>

          <h3 class="common-title" id="countByRelationship">続柄別アカウント数</h3>
          <button class="item" @click="downloadCSV(countByRelationshipRows, '続柄別アカウント数')">Download CSV</button>
          <br>
          <div class="item" style="max-width: 600px">
            <vue-good-table
              :columns="countByRelationshipColumns"
              :rows="countByRelationshipRows"
              max-height="400px"
              :fixed-header="true"
              :line-numbers="true"
              :sort-options="{
                enabled: true,
                initialSortBy: {field: 'relationship', type: 'asc'}
              }"  
            >
            </vue-good-table>
          </div>
          <div class="item" style="max-width: 600px; margin-top: 15px">
            <Chart 
              :def="chartDefPie"
              :data="countByRelationshipChartData"
            >
            </Chart>
          </div>
          <br>

          <h3 class="common-title" id="counselingStaticDaily">新規相談数（日次）</h3>
          <button class="item" @click="downloadCSV(counselingStaticDailyRows, '新規相談数（日次）')">Download CSV</button>
          <br>
          <div class="item" style="max-width: 600px">
            <vue-good-table
              :columns="counselingStaticDailyColumns"
              :rows="counselingStaticDailyRows"
              max-height="400px"
              :fixed-header="true"
              :line-numbers="true"
              :sort-options="{
                enabled: true,
                initialSortBy: {field: 'createAt', type: 'desc'}
              }"    
            >
            </vue-good-table>
          </div>
          <div class="item" style="max-width: 600px; margin-top: 15px">
            <Chart 
              :def="chartDefBar"
              :data="counselingStaticDailyChartData"
            >
            </Chart>
          </div>
          <br>

          <h3 class="common-title" id="counselingStaticMonthly">新規相談数（月次）</h3>
          <button class="item" @click="downloadCSV(counselingStaticMonthlyRows, '新規相談数（月次）')">Download CSV</button>
          <br>
          <div class="item" style="max-width: 600px">
            <vue-good-table
              :columns="counselingStaticMonthlyColumns"
              :rows="counselingStaticMonthlyRows"
              max-height="400px"
              :fixed-header="true"
              :line-numbers="true"
              :sort-options="{
                enabled: true,
                initialSortBy: {field: 'createAt', type: 'desc'}
              }"    
            >
            </vue-good-table>
          </div>
          <div class="item" style="max-width: 600px; margin-top: 15px">
            <Chart 
              :def="chartDefBar"
              :data="counselingStaticMonthlyChartData"
            >
            </Chart>
          </div>
          <br>

          <h3 class="common-title" id="counselingStaticPerson">一人あたりの相談件数</h3>
          <button class="item" @click="downloadCSV(counselingStaticPersonRows, '一人あたりの相談件数')">Download CSV</button>
          <br>
          <div class="item" style="max-width: 600px">
            <vue-good-table
              :columns="counselingStaticPersonColumns"
              :rows="counselingStaticPersonRows"
              max-height="400px"
              :fixed-header="true"
              :line-numbers="true"
              :sort-options="{
                enabled: true,
                initialSortBy: {field: 'counselingCount', type: 'desc'}
              }"    
            >
            </vue-good-table>
          </div>
          <div class="item" style="max-width: 600px; margin-top: 15px">
            <Chart 
              :def="chartDefBar"
              :data="counselingStaticPersonChartData"
            >
            </Chart>
          </div>
          <br>
          
          <h3 class="common-title" id="averageCounselingStaticPerson">一人あたりの平均相談件数</h3>
          <span class="item">{{averageCounselingStaticPerson}} 件</span>
          <br>
          <br>
          <h3 class="common-title" id="averageActiveUserCounselingStaticPerson">1件以上の相談をしたことがあるユーザーにおける、一人あたりの平均相談件数</h3>
          <span class="item">{{averageActiveUserCounselingStaticPerson}} 件</span>
          <br>
          <br>

          <h3 class="common-title" id="totalCounselingCount">合計相談件数</h3>
          <span class="item">{{totalCounselingCount}} 件</span>
          <br>
          <br>

          <h3 class="common-title" id="totalTimelineCount">合計タイムライン数</h3>
          <span class="item">{{totalTimelineCount}} 件</span>
          <br>
          <br>

          <h3 class="common-title" id="timelineUsage">タイムライン使用ユーザー率</h3>
          <span class="item">{{timelineUsage}} %</span>
          <br>
          <br>
<!--
          <h3 class="common-title">合計：{{totalCount}}件</h3>
          <dl class="item">
            <template v-if="userData">
              <ul v-for="user in userData" :key="user.id" class="text-box box-green">
                <li><img width="75" :src="user.iconUrl" alt="" /></li>
                <li><b>アカウント種別</b>： {{user.type}}</li>
                <li><b>ID</b>： {{user.id}}</li>
                <li><b>メールアドレス</b>： {{user.mailAddress}}</li>
                <li><b>表示名</b>： {{user.displayName}}</li>
                <li><b>姓</b>： {{user.lastName}}</li>
                <li><b>名</b>： {{user.firstName}}</li>-->
                <!--<li><b>続柄</b>： {{user.relationship}}</li>--><!-- user only -->
                <!--<li><b>生年月日</b>： {{user.birthDate}}</li>
                <li><b>性別</b>： {{user.gender}}</li>
                <li><b>日本在住</b>： {{user.isLiveInJapan}}</li>
                <li><b>郵便番号</b>： {{user.postalCode}}</li>
                <li><b>がん種</b>： {{user.cancerType}}</li>-->
                <!--<li><b>ステージ</b>： {{user.cancerStage}}</li>--><!-- user only -->
                <!--<li><b>がんと診断された年月日</b>： {{user.diagnosedDate}}</li>--><!-- user only -->
                <!--<li><b>がんが発見されたきっかけ</b>： {{user.diagnosedReason}}</li>--><!-- user only -->
                <!--<li><b>現在かかっている病院・診療科</b>： {{user.hospitalName}}</li>--><!-- user only -->
                <!--<li><b>現在の状況</b>： {{user.curativeStatus}}</li>--><!-- user only -->
                <!--<li><b>罹患歴</b>： {{user.cancerHistory}}</li>--><!-- user only -->
                <!--<li><b>罹患歴のあるがん種</b>： {{user.diagnosedCancerType}}</li>--><!-- adviser only-->
                <!--<li><b>専門分野</b>： {{user.specialty}}</li>--><!-- adviser only-->
                <!--<li><b>所属</b>： {{user.affiliation}}</li>--><!-- adviser only-->
                <!--<li><b>肩書</b>： {{user.businessTitle}}</li>--><!-- adviser only-->
                <!--<li><b>資格</b>： {{user.licentiate}}</li>--><!-- adviser only-->
                <!--<li><b>プロフィール</b>： {{user.profile}}</li>--><!-- adviser only-->
                <!--<li><b>会員情報登録日</b>： {{user.createAt | date}}</li>-->
                <!--<li><b>会員情報最終更新日</b>： {{user.updateAt | date}}</li>-->
              <!--</ul>
            </template>
            <template v-else>
              <div class="loading"></div>
            </template>
          </dl>
-->          
        </template>
        <template v-else-if="isStaff">
          <dl class="item">
            管理者権限が必要です
          </dl>
        </template>
        <template v-else>
        </template>
      </template>

      <!-- 認証していない時はログイン画面を表示 -->
      <template v-else>
        <LoginItem :createButton="false" />
      </template>
    </main>
    <FooterItem :contactUrl="contactUrl" :hiddenFooterFixedButton="true" />
  </div>
</template>

<script>
import { API, Auth, Storage, graphqlOperation, Analytics, Logger } from 'aws-amplify'
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'

import { listStaffAllowListsBySpecificUser } from './graphql/queries'
import { listUsers } from "./graphql/queries"
import { listCounselingTopicss } from "./graphql/queries"
import { listTimelines } from "./graphql/queries"
import { createErrorLog } from "./graphql/mutations"

import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'

import Chart from 'vue-chartless'

import { Common } from './Common.js'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

const logger = new Logger('AdminInsight');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'AdminInsight',
  components: {
    HeaderItem,
    FooterItem,
    LoginItem,
    VueGoodTable,
    Chart
  },
  mixins:[Common],
  data() {
    return {
      authState: undefined,
      unsubscribeAuth: undefined,
      id: '',
      mailaddress: '',
      signedIn: false,
      isStaff: false,
      isAdmin: false,
      contactUrl: '',
      userData: null,
      
      totalUserCount: 0,

      chartDefBar : {
        type : 'bar',
      },
      chartDefPie : {
        type : 'pie',
      },

      createAtStaticDailyColumns: [
        {
          label: 'アカウント作成日',
          field: 'createAt',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'yyyy-MM-dd',//'MMM do yy',
        },
        {
          label: '登録者数',
          field: 'count',
          tyle: 'number',
        }
      ],
      createAtStaticDailyRows: null,
      createAtStaticDailyChartData : null,

      createAtStaticMonthlyColumns: [
        {
          label: 'アカウント作成月',
          field: 'createAt',
          type: 'string',
          dateInputFormat: 'yyyy-MM',
          dateOutputFormat: 'yyyy-MM',//'MMM do yy',
        },
        {
          label: '登録者数',
          field: 'count',
          tyle: 'number',
        }
      ],
      createAtStaticMonthlyRows: null,
      createAtStaticMonthlyChartData : null,

      averageAge: 0,

      countByGenerationColumns: [
        {
          label: '年代',
          field: 'generation',
          type: 'string',
        },
        {
          label: '登録者数',
          field: 'count',
          tyle: 'number',
        }
      ],
      countByGenerationRows: null,
      countByGenerationChartData : null, 

      countByGenderColumns: [
        {
          label: '性別',
          field: 'gender',
          type: 'string',
        },
        {
          label: '登録者数',
          field: 'count',
          tyle: 'number',
        }
      ],
      countByGenderRows: null,
      countByGenderChartData : null, 

      countByCancerTypeColumns: [
        {
          label: 'がん種',
          field: 'cancerType',
          type: 'string',
        },
        {
          label: '登録者数',
          field: 'count',
          tyle: 'number',
        }
      ],
      countByCancerTypeRows: null,
      countByCancerTypeChartData : null, 

      countByCancerStageColumns: [
        {
          label: 'がんステージ',
          field: 'cancerStage',
          type: 'string',
        },
        {
          label: '登録者数',
          field: 'count',
          tyle: 'number',
        }
      ],
      countByCancerStageRows: null,
      countByCancerStageChartData : null, 

      countByCurativeStatusColumns: [
        {
          label: '現在の状況',
          field: 'curativeStatus',
          type: 'string',
        },
        {
          label: '登録者数',
          field: 'count',
          tyle: 'number',
        }
      ],
      countByCurativeStatusRows: null,
      countByCurativeStatusChartData : null, 

      countByRelationshipColumns: [
        {
          label: '続柄',
          field: 'relationship',
          type: 'string',
        },
        {
          label: '登録者数',
          field: 'count',
          tyle: 'number',
        }
      ],
      countByRelationshipRows: null,
      countByRelationshipChartData : null, 

      counselingStaticDailyColumns: [
        {
          label: '相談作成日',
          field: 'createAt',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'yyyy-MM-dd',//'MMM do yy',
        },
        {
          label: '相談数',
          field: 'count',
          tyle: 'number',
        }
      ],
      counselingStaticDailyRows: null,
      counselingStaticDailyChartData : null,

      counselingStaticMonthlyColumns: [
        {
          label: '相談作成月',
          field: 'createAt',
          type: 'date',
          dateInputFormat: 'yyyy-MM',
          dateOutputFormat: 'yyyy-MM',//'MMM do yy',
        },
        {
          label: '相談数',
          field: 'count',
          tyle: 'number',
        }
      ],
      counselingStaticMonthlyRows: null,
      counselingStaticMonthlyChartData : null,

      counselingStaticPersonColumns: [
        {
          label: '相談件数',
          field: 'counselingCount',
          type: 'number',
        },
        {
          label: '該当者数',
          field: 'count',
          tyle: 'number',
        }
      ],
      counselingStaticPersonRows: null,
      counselingStaticPersonChartData : null,

      averageCounselingStaticPerson: 0,

      averageActiveUserCounselingStaticPerson: 0,

      totalCounselingCount: 0,

      totalTimelineCount: 0,

      timelineUsage: 0,
    }
  },
  
  filters: {
  },
  
  created () {
    this.refresh()
  },

  methods: {
    refresh () {
      Storage.list('')
        .then(result => 
          this.s3Data = JSON.parse(JSON.stringify(result))
        )
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'AdminInsight',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Image List : Storage.list',
              errorNumber: 'AdminInsight-01',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'AdminInsight',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Image List : Storage.list',
            errorNumber: 'AdminInsight-01',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
        })
    },

    download(key, num, type, i, identityId) {
      Storage.get(key, { level: 'protected', identityId: identityId })
        .then(result => {
          //console.log(result)
          
          if (!key) {
            result = null
          }
          if (type === 'icon' && result && this.userData[i] !== undefined) {
            var tmpData = this.userData[i]
            tmpData.iconUrl = result
            this.userData.splice(i, 1, tmpData)
            return result
          } else {
            /*
            if (num === 1) {
              this.uploadedImage1 = result
            } else if (num === 2) {
              this.uploadedImage2 = result
            } else if (num === 3) {
              this.uploadedImage3 = result
            }
            */
          }
        })
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'AdminInsight',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              counselingTopicsId: this.counselingId,
              errorType: 'Image download : Storage.get',
              errorNumber: 'AdminInsight-02',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'AdminInsight',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Image download : Storage.get',
            errorNumber: 'AdminInsight-02',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
          //alert("画像の取得処理に失敗しました")
        })
    },
    
    downloadCSV(data, name) {
      let confirmResult = confirm('社外秘情報を含むファイルをダウンロードしますか？')
      if (confirmResult) {
        let csv = ''
        let headerLabel = ''
        let hasHeaderLabel = false
        data.forEach(el => {
          var line = ''
          for (let key in el) {
            line += el[key] + ','
            if (!hasHeaderLabel) {
              headerLabel += key + ','
            }
          }
          if (!hasHeaderLabel) {
            headerLabel = '\ufeff' + headerLabel.slice(0, -1) + '\n'
            csv = headerLabel + csv
            hasHeaderLabel = true
          }
          line = line.slice(0, -1) + '\n'
          csv += line
        })
        var blob = new Blob([ csv ], { "type" : "csv/plain" });
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = '【社外秘】' + name + '.csv'
        link.click()
      }
    },

    getDate (value) {
      var valueDate = new Date(value)
      var valueFormat = 'YYYY-MM-DD'
      valueFormat = valueFormat.replace(/YYYY/, valueDate.getFullYear())
      
      if (valueDate.getMonth() + 1 < 10) {
        valueFormat = valueFormat.replace(/MM/, '0' + (valueDate.getMonth() + 1))
      } else {
        valueFormat = valueFormat.replace(/MM/, valueDate.getMonth() + 1)
      }
      
      if (valueDate.getDate() < 10) {
        valueFormat = valueFormat.replace(/DD/, '0' + valueDate.getDate())
      } else {
        valueFormat = valueFormat.replace(/DD/, valueDate.getDate())
      }
      
      return valueFormat
    },

    getAge (birthDate, nowDate) {
      let age = nowDate.getFullYear() - birthDate.getFullYear()
      let thisYearsBirthday  = new Date(nowDate.getFullYear(), birthDate.getMonth(), birthDate.getDate())
      return age + (thisYearsBirthday.getTime() > nowDate.getTime() ? -1 : 0)
    },
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },

  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });
    
    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email

      let currentCredentials = await Auth.currentCredentials()
      this.identityId = currentCredentials.identityId
    } catch (err) {
      this.signedIn = false
    }

    // 運営アカウントか判定
    try {
      let staffAllowData = await API.graphql(
        graphqlOperation(listStaffAllowListsBySpecificUser, {
          mailAddress: this.mailaddress,
          limit: 1
        })
      )
      if (
        staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
        this.mailaddress
      ) {
        // 運営モード
        this.isStaff = true
        this.contactUrl = ''

        if (staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].isAdmin) {
          this.isAdmin = true
        } else {
          this.isAdmin = false
        }
      } else {
        this.isStaff = false
        this.isAdmin = false
        this.contactUrl = ''
        this.$router.push({ path: 'dashboard' })
      }
    } catch (err) {
      this.isStaff = false
      this.isAdmin = false
      this.contactUrl = ''
      this.$router.push({ path: '../dashboard' })    
    }

    // 情報取得
    if (this.isAdmin || this.isStaff) {
      try {
        this.userData = await API.graphql(graphqlOperation(
          listUsers , {limit: 99999}
        ))
        this.userData = this.userData.data.listUsers.items

        this.userData.sort (function(a, b) {
          if (new Date(a.createAt) > new Date(b.createAt)) {
            return -1
          } else {
            return 1
          }
        })

        // 数値集計
        // table拡張: https://www.kabanoki.net/3230/
        //     https://xaksis.github.io/vue-good-table/guide/configuration/#fixed-header
        
        // ユーザー情報
        var tmpCreateAtDailyStatic = {}
        var tmpCreateAtMonthlyStatic = {}
        var totalAge = 0
        var tmpCountByGeneration = {}
        var tmpCountByGender = {}
        var tmpCountByCancerType = {}
        var tmpCountByCancerStage = {}
        var tmpCountByCurativeStatus = {}
        var tmpCountByRelationship = {}
        for (let key in this.userData) {
          if (this.userData[key].type == 'user' && !this.isOfficialTestAccount(this.userData[key].mailAddress)) {

            // 合計ユーザー数集計
            this.totalUserCount++

            // createAt でアカウント作成日ごとの人数集計
            var createAtDate = this.getDate(this.userData[key].createAt)
            if (createAtDate in tmpCreateAtDailyStatic) {
              tmpCreateAtDailyStatic[createAtDate] = tmpCreateAtDailyStatic[createAtDate] + 1
            } else {
              tmpCreateAtDailyStatic[createAtDate] = 1
            }

            // createAt でアカウント作成月ごとの人数集計
            var createAtMonth = this.getDate(this.userData[key].createAt).slice(0, -3)
            if (createAtMonth in tmpCreateAtMonthlyStatic) {
              tmpCreateAtMonthlyStatic[createAtMonth] = tmpCreateAtMonthlyStatic[createAtMonth] + 1
            } else {
              tmpCreateAtMonthlyStatic[createAtMonth] = 1
            }


            
            // birthDate で平均年齢
            let birthDate = this.userData[key].birthDate
            let age = this.getAge(new Date(birthDate), new Date())
            totalAge += age
            
            // birthDate で年代ごとの人数を集計
            let generation = ''
            if (age < 10) {
              generation = '10代未満'
            } else if (10 <= age && age < 20) {
              generation = '10代'
            } else if (20 <= age && age < 30) {
              generation = '20代'
            } else if (30 <= age && age < 40) {
              generation = '30代'
            } else if (40 <= age && age < 50) {
              generation = '40代'
            } else if (50 <= age && age < 60) {
              generation = '50代'
            } else if (60 <= age && age < 70) {
              generation = '60代'
            } else if (70 <= age && age < 80) {
              generation = '70代'
            } else if (80 <= age && age < 90) {
              generation = '80代'
            } else {
              generation = '90代以上'
            }

            if (generation in tmpCountByGeneration) {
              tmpCountByGeneration[generation] = tmpCountByGeneration[generation] + 1
            } else {
              tmpCountByGeneration[generation] = 1
            }

            // gener で性別ごとの人数を集計
            var gender = this.userData[key].gender
            if (gender in tmpCountByGender) {
              tmpCountByGender[gender] = tmpCountByGender[gender] + 1
            } else {
              tmpCountByGender[gender] = 1
            }

            // cancerType でがん種ごとの人数を集計
            var cancerTypes = JSON.parse(this.userData[key].cancerType)
            // JSONを分解して集計
            for (var i = 0; i < cancerTypes.length; i++) {

              if (cancerTypes[i] in tmpCountByCancerType) {
                tmpCountByCancerType[cancerTypes[i]] = tmpCountByCancerType[cancerTypes[i]] + 1
              } else {
                tmpCountByCancerType[cancerTypes[i]] = 1
              }
            }

            // cancerStage でがんステージごとの人数を集計
            var cancerStage = this.userData[key].cancerStage
            if (cancerStage in tmpCountByCancerStage) {
              tmpCountByCancerStage[cancerStage] = tmpCountByCancerStage[cancerStage] + 1
            } else {
              tmpCountByCancerStage[cancerStage] = 1
            }

            // curativeStatus で現在の状況ごとの人数を集計
            var curativeStatus = this.userData[key].curativeStatus
            if (curativeStatus in tmpCountByCurativeStatus) {
              tmpCountByCurativeStatus[curativeStatus] = tmpCountByCurativeStatus[curativeStatus] + 1
            } else {
              tmpCountByCurativeStatus[curativeStatus] = 1
            }

            // relationship で続柄ごとの人数を集計
            var relationship = this.userData[key].relationship
            if (relationship in tmpCountByRelationship) {
              tmpCountByRelationship[relationship] = tmpCountByRelationship[relationship] + 1
            } else {
              tmpCountByRelationship[relationship] = 1
            }
            
          }
        }

        // 新規アカウント登録者数（日次）
        var tmpCreateAtStaticDailyRows = []
        var tmpCreateAtStaticDailyChartData = []
        for (let key in tmpCreateAtDailyStatic) {
          tmpCreateAtStaticDailyRows.push({ createAt: key, count: tmpCreateAtDailyStatic[key] })
          tmpCreateAtStaticDailyChartData.push({ label: key, value: tmpCreateAtDailyStatic[key] })
        }
        this.createAtStaticDailyRows = tmpCreateAtStaticDailyRows
        this.createAtStaticDailyChartData = tmpCreateAtStaticDailyChartData

        // 新規アカウント登録者数（月次）
        var tmpCreateAtStaticMonthlyRows = []
        var tmpCreateAtStaticMonthlyChartData = []
        for (let key in tmpCreateAtMonthlyStatic) {
          tmpCreateAtStaticMonthlyRows.push({ createAt: key, count: tmpCreateAtMonthlyStatic[key] })
          tmpCreateAtStaticMonthlyChartData.push({ label: key, value: tmpCreateAtMonthlyStatic[key] })
        }
        this.createAtStaticMonthlyRows = tmpCreateAtStaticMonthlyRows
        this.createAtStaticMonthlyChartData = tmpCreateAtStaticMonthlyChartData

        // 平均年齢
        this.averageAge = totalAge / this.totalUserCount

        // 世代別アカウント数
        var tmpCountByGenerationRows = []
        var tmpCountByGenerationChartData = []
        for (let key in tmpCountByGeneration) {
          tmpCountByGenerationRows.push({ generation: key, count: tmpCountByGeneration[key] })
          tmpCountByGenerationChartData.push({ label: key, value: tmpCountByGeneration[key] })
        }
        this.countByGenerationRows = tmpCountByGenerationRows
        this.countByGenerationChartData = tmpCountByGenerationChartData

        // 性別別アカウント数
        var tmpCountByGenderRows = []
        var tmpCountByGenderChartData = []
        for (let key in tmpCountByGender) {
          tmpCountByGenderRows.push({ gender: key, count: tmpCountByGender[key] })
          tmpCountByGenderChartData.push({ label: key, value: tmpCountByGender[key] })
        }
        this.countByGenderRows = tmpCountByGenderRows
        this.countByGenderChartData = tmpCountByGenderChartData

        // がん種別アカウント数
        var tmpCountByCancerTypeRows = []
        var tmpCountByCancerTypeChartData = []
        for (let key in tmpCountByCancerType) {
          tmpCountByCancerTypeRows.push({ cancerType: key, count: tmpCountByCancerType[key] })
          tmpCountByCancerTypeChartData.push({ label: key, value: tmpCountByCancerType[key] })
        }
        this.countByCancerTypeRows = tmpCountByCancerTypeRows
        this.countByCancerTypeChartData = tmpCountByCancerTypeChartData

        // がんステージ別アカウント数
        var tmpCountByCancerStageRows = []
        var tmpCountByCancerStageChartData = []
        for (let key in tmpCountByCancerStage) {
          if (key !== 'null') {
            tmpCountByCancerStageRows.push({ cancerStage: key, count: tmpCountByCancerStage[key] })
            tmpCountByCancerStageChartData.push({ label: key, value: tmpCountByCancerStage[key] })
          }
        }
        this.countByCancerStageRows = tmpCountByCancerStageRows
        this.countByCancerStageChartData = tmpCountByCancerStageChartData

        // 現在の状況別アカウント数
        var tmpCountByCurativeStatusRows = []
        var tmpCountByCurativeStatusChartData = []
        for (let key in tmpCountByCurativeStatus) {
          if (key !== 'null') {
            tmpCountByCurativeStatusRows.push({ curativeStatus: key, count: tmpCountByCurativeStatus[key] })
            tmpCountByCurativeStatusChartData.push({ label: key, value: tmpCountByCurativeStatus[key] })
          }
        }
        this.countByCurativeStatusRows = tmpCountByCurativeStatusRows
        this.countByCurativeStatusChartData = tmpCountByCurativeStatusChartData

        // 続柄別アカウント数
        var tmpCountByRelationshipRows = []
        var tmpCountByRelationshipChartData = []
        for (let key in tmpCountByRelationship) {
          if (key !== 'null') {
            tmpCountByRelationshipRows.push({ relationship: key, count: tmpCountByRelationship[key] })
            tmpCountByRelationshipChartData.push({ label: key, value: tmpCountByRelationship[key] })
          }
        }
        this.countByRelationshipRows = tmpCountByRelationshipRows
        this.countByRelationshipChartData = tmpCountByRelationshipChartData


        // 相談情報
        var tmpCounselingDailyStatic = {}
        var tmpCounselingMonthlyStatic = {}
        var tmpCounselingPersonStatic = {}
        var totalCounselingCount = 0

        var counselingData = await API.graphql(graphqlOperation(
          listCounselingTopicss , {limit: 99999}
        ))     
        counselingData = counselingData.data.listCounselingTopicss.items
        counselingData.sort (function(a, b) {
          if (new Date(a.createAt) > new Date(b.createAt)) {
            return -1
          } else {
            return 1
          }
        })
        
        for (let key in counselingData) {
          // createAt で相談作成日ごとの人数集計
          var counselingAtDate = this.getDate(counselingData[key].createAt)
          if (counselingAtDate in tmpCounselingDailyStatic) {
            tmpCounselingDailyStatic[counselingAtDate] = tmpCounselingDailyStatic[counselingAtDate] + 1
          } else {
            tmpCounselingDailyStatic[counselingAtDate] = 1
          }

          // createAt で相談作成月ごとの人数集計
          var counselingMonth = this.getDate(counselingData[key].createAt).slice(0, -3)
          if (counselingMonth in tmpCounselingMonthlyStatic) {
            tmpCounselingMonthlyStatic[counselingMonth] = tmpCounselingMonthlyStatic[counselingMonth] + 1
          } else {
            tmpCounselingMonthlyStatic[counselingMonth] = 1
          }

          // counselingUserid で相談作成者ごとの人数集計
          var counselingPerson = counselingData[key].counselingUserid
          if (counselingPerson in tmpCounselingPersonStatic) {
            tmpCounselingPersonStatic[counselingPerson] = tmpCounselingPersonStatic[counselingPerson] + 1
          } else {
            tmpCounselingPersonStatic[counselingPerson] = 1
          }

          // 合計相談数
          totalCounselingCount++
        }

        // タイムライン情報
        var timelineData = await API.graphql(graphqlOperation(
          listTimelines , {limit: 99999}
        ))     
        timelineData = timelineData.data.listTimelines.items

        
        // 新規アカウント登録者数（日次）
        var tmpCounselingStaticDailyRows = []
        var tmpCounselingStaticDailyChartData = []
        for (let key in tmpCounselingDailyStatic) {
          tmpCounselingStaticDailyRows.push({ createAt: key, count: tmpCounselingDailyStatic[key] })
          tmpCounselingStaticDailyChartData.push({ label: key, value: tmpCounselingDailyStatic[key] })
        }
        this.counselingStaticDailyRows = tmpCounselingStaticDailyRows
        this.counselingStaticDailyChartData = tmpCounselingStaticDailyChartData

        // 新規アカウント登録者数（月次）
        var tmpCounselingStaticMonthlyRows = []
        var tmpCounselingStaticMonthlyChartData = []
        for (let key in tmpCounselingMonthlyStatic) {
          tmpCounselingStaticMonthlyRows.push({ createAt: key, count: tmpCounselingMonthlyStatic[key] })
          tmpCounselingStaticMonthlyChartData.push({ label: key, value: tmpCounselingMonthlyStatic[key] })
        }
        this.counselingStaticMonthlyRows = tmpCounselingStaticMonthlyRows
        this.counselingStaticMonthlyChartData = tmpCounselingStaticMonthlyChartData

        // 一人あたりの相談件数
        var tmpCounselingStaticPersonRows = []
        var tmpCounselingStaticPersonChartData = []
        var tmpCounselingPersonCountStatic = []
        var tmpCounselingCount = 0
        var tmpActiveUserCount = 0
        var tmpActiveUserCounselingCount = 0
        for (let key in tmpCounselingPersonStatic) {
          if (tmpCounselingPersonStatic[key] in tmpCounselingPersonCountStatic) {
            tmpCounselingPersonCountStatic[tmpCounselingPersonStatic[key]] = tmpCounselingPersonCountStatic[tmpCounselingPersonStatic[key]] + 1
          } else {
            tmpCounselingPersonCountStatic[tmpCounselingPersonStatic[key]] = 1
          }
          tmpCounselingCount++

          if (tmpCounselingPersonStatic[key] > 0) {
            tmpActiveUserCounselingCount = tmpActiveUserCounselingCount + tmpCounselingPersonStatic[key]
            tmpActiveUserCount++
          }
        }
        tmpCounselingPersonCountStatic[0] = this.totalUserCount - tmpCounselingCount

        for (let key in tmpCounselingPersonCountStatic) {
          tmpCounselingStaticPersonRows.push({ counselingCount: key, count: tmpCounselingPersonCountStatic[key] })
          tmpCounselingStaticPersonChartData.push({ label: key, value: tmpCounselingPersonCountStatic[key] })
        }
        this.counselingStaticPersonRows = tmpCounselingStaticPersonRows
        this.counselingStaticPersonChartData = tmpCounselingStaticPersonChartData

        // 一人あたりの平均相談件数
        this.averageCounselingStaticPerson = totalCounselingCount / this.totalUserCount

        // 1件以上の相談をしたことがあるユーザーにおける、一人あたりの平均相談件数
        this.averageActiveUserCounselingStaticPerson = tmpActiveUserCounselingCount / tmpActiveUserCount

        // 合計相談件数
        this.totalCounselingCount = totalCounselingCount

        // 合計タイムライン件数
        this.totalTimelineCount = timelineData.length

        // タイムライン使用率
        this.timelineUsage = (this.totalTimelineCount / this.totalUserCount) * 100

      } catch (err) {
        this.userData = []
      }
    }
    
    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'AdminInsight',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: ''
      }
    });

  }
}
</script>
<style>
</style>
<style src="./assets/style.css" />
